import { createBrowserRouter, redirect } from "react-router";
import { Suspense, lazy } from "react";
import App from "./App";
import { ROUTES } from "@/shared/model/routes";
import { AppHeader } from "@/features/header";
import { fetchCurrentUser } from "@/shared/model/api";
import { ErrorBoundary } from "@/shared/ui/ErrorBoundary";
import { ALL_DEPT_PAGES } from "@/features/departments/dept-config";

const Board = lazy(() => import("@/features/board/board.page").then((m) => ({ default: m.Board })));
const AdminPage = lazy(() => import("@/features/admin/admin.page").then((m) => ({ default: m.AdminPage })));

const PageFallback = <div className="p-8 text-center text-gray-400">Загрузка...</div>;

const getToken = () => localStorage.getItem("token");

const authLoader = () => {
  if (!getToken()) return redirect(ROUTES.LOGIN);
  return null;
};

export const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      {
        path: ROUTES.LOGIN,
        loader: () => {
          if (getToken()) return redirect(ROUTES.BOARD);
          return null;
        },
        lazy: () => import("@/features/auth/login.page"),
      },
      {
        path: ROUTES.HOME,
        loader: () => redirect(ROUTES.BOARD),
      },
      {
        path: ROUTES.BOARD,
        loader: authLoader,
        element: (
          <>
            <AppHeader />
            <ErrorBoundary>
              <Suspense fallback={PageFallback}>
                <Board />
              </Suspense>
            </ErrorBoundary>
          </>
        ),
      },

      // Маршруты отделов — генерируются из dept-config.tsx
      ...ALL_DEPT_PAGES.map((page) => ({
        path: page.path,
        loader: authLoader,
        element: (
          <>
            <AppHeader />
            <ErrorBoundary>
              <Suspense fallback={PageFallback}>
                <page.component />
              </Suspense>
            </ErrorBoundary>
          </>
        ),
      })),

      {
        path: ROUTES.ADMIN,
        loader: async () => {
          if (!getToken()) return redirect(ROUTES.LOGIN);
          try {
            const user = await fetchCurrentUser();
            if (user.role !== "ADMIN") return redirect(ROUTES.BOARD);
          } catch {
            localStorage.removeItem("token");
            return redirect(ROUTES.LOGIN);
          }
          return null;
        },
        element: (
          <>
            <AppHeader />
            <ErrorBoundary>
              <Suspense fallback={PageFallback}>
                <AdminPage />
              </Suspense>
            </ErrorBoundary>
          </>
        ),
      },
    ],
  },
]);
